import React from 'react'
import img2070 from '../components/images/adflipkart.jpg'
import img2071 from '../components/images/adflipkart11.png'
import img2072 from '../components/images/adflipkart22.png'

const events = () => {
    return (

        <>
            <div className="row  m-2">
                <img src={img2070} alt='flipkart' />
            </div>
            <div className='container'>
                <h2>Introduction To Flipkart Ads</h2>
                <p>
                    Drive sales and visibility with targeted advertising on Flipkart, a prominent online marketplace with a vast customer base. Utilize advanced targeting options to effectively reach your target audience, optimize campaigns for optimal return on investment (ROI), and enhance brand visibility. Leverage Flipkart Ads’ robust analytics to refine your strategies and stay competitive in the e-commerce industry.
                </p>

                <div className='row'>
                    <h2 className='text-center' >Product Listing Ads (PLA)</h2>
                    <p className='text-center'>Flipkart’s Product Listing Ads (PLAs) are designed to enhance brand visibility and drive lead generation effectively. These ads allow brands to showcase their products to targeted or high-intent customers on Flipkart’s app and website, operating on a CPC (Cost Per Click) model.</p>
                    <div className='col'>

                        <ol>
                            <li><b>1.	Ad Placement:</b>
                                <p> PLAs appear prominently on various Flipkart pages, including the home page, product pages, and top positions in search and browse listings.</p>
                            </li>
                            <li><b>2.	Seller Selection:</b>
                                <p>Choose your preferred authorized seller to avoid spending with unauthorized sellers, ensuring control over brand representation and customer experience.</p>
                            </li>
                            <li><b>3.	Targeting Options:</b>
                                <p>  PLAs utilize category targeting powered by AI, which analyzes customer search data to optimize ad reach and visibility, enhancing relevance to potential customers.</p>
                            </li>
                            <li><b>4.	Budgeting and Campaign Management:</b>
                                <p>Align your campaign budget with total spending goals. Campaigns can be managed either by budget endpoint, where ads stop running once the budget limit is reached, or by campaign end date, ensuring ads cease after a specified date.</p>
                            </li>
                            <li><b>5.	Negative Targeting:</b>
                                <p>Utilize negative targeting to exclude irrelevant keywords from your campaign, focusing on reaching a highly relevant audience effectively. This feature supports personalized and engaging ad content tailored to specific customer preferences.</p>
                            </li>

                            <p>This approach helps brands leverage Flipkart’s robust advertising platform to maximize product visibility, drive sales, and maintain control over brand messaging and customer interactions.</p>

                        </ol>
                    </div>
                    <div className='col'>
                        <img src={img2071} alt='Queryimg' />
                    </div>
                </div >

                <div className='row'>
                    <h2 className='text-center' >Product contextual Ads (PCA)</h2>
                    <p className='text-center'>Flipkart’s PCA (Product Listing Ads) are tailored for intent-based marketing, effectively reaching a highly relevant user base already interested in your product category through rich media formats, boosting brand visibility.</p>
                    <div className='col'>

                        <ol>
                            <li><b>1.	Ad Placement:</b>
                                <p> PCA Ads appear prominently at the top of search results and throughout the rest of the page, ensuring maximum exposure to potential customers.</p>
                            </li>
                            <li><b>2.	Campaign Types:</b>
                                <p>a)  Rule-based Selection:** Customize campaigns based on specific rules, such as special discounts or product pricing, to efficiently target your audience.
                                    b)  ADHOC Selection: Select specific products or FSNs (Flipkart Serial Numbers) to display ads, providing flexibility in campaign management and product visibility
                                </p>
                            </li>
                            <li><b>3.	Key Features of PCA Ads:</b>
                                <p>a)  Multiple Ad Groups: Create multiple ad groups within a campaign to optimize targeting and efficiency, with the option to set different CPCs for each group.
                                    b)  Targeting Options: Target ads based on category and sub-category levels, ensuring precise reach to audiences interested in specific product types like running shoes or hiking gear.
                                    c)  Budgeting and Campaign Management: Set daily budgets and total ad spends for each campaign, with the ability to cap spending to manage costs effectively across multiple campaigns.
                                </p>
                            </li>
                            <li><b>4.	Custom Ad Creatives:</b>
                                <p>Design custom ad banners with text, images, and multimedia content to enhance visibility and engagement. Upload up to three images and use two taglines to attract customer attention effectively.</p>
                            </li>
                            <li><b>5.	Negative Targeting:</b>
                                <p>– Utilize keyword-level negative targeting (up to 2000 characters) to exclude irrelevant audience segments from seeing your ads, ensuring your campaigns reach the most relevant potential customers.</p>
                            </li>

                            <p>This approach empowers sellers on Flipkart to maximize ad effectiveness, drive sales, and enhance brand recognition through targeted, customizable advertising solutions.</p>

                        </ol>
                    </div>
                    <div className='col'>
                        <img src={img2072} alt='Queryimg' />
                    </div>
                </div >
            </div>
        </>
    )
}

export default events